import slice from './slice';

export const { setJoystickStatus, setCameraStatus, resetEquipmentStatus } = slice.actions;

